var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-qr-generator",class:{
    'without-card': !_vm.card,
    'button-outline': _vm.buttonStyle === 'outline',
  }},[_c('div',{ref:"qrCodeWrapper",staticClass:"qr-code-wrapper"},[_c('qrcode-vue',{attrs:{"value":_vm.value || '',"size":_vm.size,"level":"M","foreground":"#111111","background":"#ffffff"}})],1),_c('button',{staticClass:"download-qr-btn",attrs:{"type":"button","disabled":!_vm.value},on:{"click":_vm.downloadQrCode}},[_vm._v("\n    "+_vm._s(_vm.downloadLabel)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }